export const calculateByteSize = (str: string) => new Blob([str]).size;
